import React, { useState } from 'react';
import { useApp } from '../contexts/AppContext';
import AddUserModal from '../components/users/AddUserModal';
import EditUserModal from '../components/users/EditUserModal';

export default function UsersPage() {
  const { users, usersLoading, usersError, deleteUser, currentUser: currentUsername, currentUserType } = useApp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const handleDelete = async (uuid, username) => {
    if (window.confirm(`Are you sure you want to delete user "${username}"?`)) {
      try {
        await deleteUser(uuid);
      } catch (error) {
        alert('Failed to delete user: ' + (error.message || 'Unknown error'));
      }
    }
  };

  const handleEdit = (user) => {
    setSelectedUser(user);
    setIsEditModalOpen(true);
  };

  if (usersLoading) {
    return (
      <section className="content-section active">
        <div className="section-header">
          <h2>User Management</h2>
        </div>
        <p>Loading users...</p>
      </section>
    );
  }

  if (usersError) {
    return (
      <section className="content-section active">
        <div className="section-header">
          <h2>User Management</h2>
        </div>
        <p className="form-error">Error loading users: {usersError.message}</p>
      </section>
    );
  }

  return (
    <section className="content-section active">
      <div className="section-header">
        <div>
          <h2>User Management</h2>
          <p>Invite teammates and manage their roles</p>
        </div>
        <button className="btn btn-primary" onClick={() => setIsModalOpen(true)}>+ Create User</button>
      </div>

      <div className="campaigns-grid">
        <table className="campaigns-table">
          <thead>
            <tr>
              <th>Username</th>
              <th>Role</th>
              <th>Created At</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.length === 0 ? (
              <tr>
                <td colSpan="4" style={{ textAlign: 'center', padding: '2rem' }}>
                  No users found
                </td>
              </tr>
            ) : (
              users.map((user) => (
                <tr key={user.uuid}>
                  <td className="campaign-name-cell">{user.username}</td>
                  <td>
                    <span className={`badge badge-${user.role}`}>{user.role}</span>
                  </td>
                  <td>{new Date(user.createdAt).toLocaleString()}</td>
                  <td className="campaign-actions-cell">
                    {currentUserType === 'admin' && (
                      <button 
                        className="btn-table-action" 
                        onClick={() => handleEdit(user)}
                      >
                        Edit
                      </button>
                    )}
                    {currentUserType === 'admin' && user.username !== currentUsername && (
                      <button 
                        className="btn-table-action danger" 
                        onClick={() => handleDelete(user.uuid, user.username)}
                      >
                        Delete
                      </button>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <AddUserModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
      <EditUserModal 
        isOpen={isEditModalOpen} 
        onClose={() => {
          setIsEditModalOpen(false);
          setSelectedUser(null);
        }}
        user={selectedUser}
      />
    </section>
  );
}
